import { useMaterialReactTable } from "material-react-table";

import { MaterialReactTable } from "material-react-table";

import { TableConfig } from "@/src-refactor/modules/private/agencies/pages/list/components/AgencyListComponent";

import { MRT_RowData } from "material-react-table";
import { Grid, styled } from "@mui/material";
const MxDataTable = <T extends MRT_RowData>(props: TableConfig<T>) => {
  const {
    options = {
      columns: [],
      data: []
    }
  } = props;

  const initialState = {
    enablePagination: false,
    enableColumnOrdering: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnFilterModes: false,
    muiTableContainerProps: {
      sx: { boxShadow: "none", maxHeight: "none" }
    },
    enableColumnPinning: true,
    enableRowVirtualization: true,
    enableStickyHeader: true,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    state: {
      density: "compact"
    },
    muiTableBodyRowProps: () => ({
      sx: {
        cursor: "pointer"
      }
    })
  };

  const optionsHook = Object.assign({}, initialState, options);

  const table = useMaterialReactTable(optionsHook);
  return (
    <ContentDataTable>
      <MaterialReactTable table={table} />
    </ContentDataTable>
  );
};

export default MxDataTable;

const ContentDataTable = styled(Grid)(({ theme }) => ({
  width: "100%",
  borderRadius: "10px",
  "*": {
    fontFamily: theme.typography.fontFamily
  },
  "& .MuiTableContainer-root": {
    maxHeight: "auto"
    // overflow: "hidden"
  },
  "& .MuiTableCell-root": {
    fontSize: theme.typography.pxToRem(14)
  },
  "& .MuiTableHead-root": {
    "& .MuiTableRow-head": {
      backgroundColor: theme.palette.grey[50],
      boxShadow: "none"
    },
    th: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: "#101828"
    }
  },
  "& .MuiTableBody-root": {
    backgroundColor: theme.palette.background.paper,
    td: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.grey[700]
    }
  }
}));
